import { useState } from "react";

import Button from "components/Button";

import "./style.scss";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  loadingLabel = "Loading…",
  errorMessage,
}) => {
    const [showWarning, setShowWarning] = useState(false);

    return (
        <div className={`confirm-modal ${isOpen ? "open-confirm-modal" : ""}`}>
            <div
                className="confirm-backdrop"
                onClick={() => {
                    onClose();
                    setShowWarning(false);
                }}
            />
            <div className="confirm-modal-content">
                {showWarning ? (
                    <>
                        <p>
                            This calculator uses gas consumption to estimate heatloss parameters. 
                            Nontypical gas loads effect the calculation in a way that will not provide a reasonable estimation for your home.
                        </p>
                        <div className="confirm-modal-content-buttons">
                            <Button
                                classNames="confirm-modal-content-buttons-cancel"
                                onClick={() => {
                                    onClose();

                                    setShowWarning(false);
                                }}
                            >
                                Close
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        {/* TODO Maybe add some title? */}
                        {/* <h2 className="confirm-modal-content-title"></h2> */}
                        {/* Swap yes and no or revisit answer wording */}
                        <p>
                            This calculator is intended for homes where space heating is provided almost entirely by a natural gas system.
                        </p>
                        <br></br>
                        <p>
                            It is not applicable to homes where other heating systems provide a significant portion of the space heating.
                        </p>
                        <br></br>
                        <p>
                            It is also <b>not</b> applicable to homes with large or highly variable natural gas loads
                            (e.g. pool heaters, hot tubs and/or saunas), or where the natural gas meter 
                            serves more than one building. Typical household gas uses (e.g., water heating, cooking, 
                            dryer, barbecue) are acceptable but must be accounted for by estimating non-space-heating 
                            gas consumption.
                        </p>
                        <br></br>
                        <p>
                            The input data should reflect the current condition of the home. If the home has changed 
                            since the data was collected (e.g., additions or other changes that increase heat loss), 
                            results may be affected. The input data must reflect typical occupancy and heating behaviour. 
                            Extended vacancy or unusual usage patterns may result in inaccurate results.
                        </p>
                        <br></br>
                        <p>
                            This tool provides an empirical estimate and may not be appropriate for all applications. 
                            The user is responsible for ensuring that the inputs are representative and that the 
                            results are used appropriately.
                        </p>
                        <br></br>
                        <p>
                            Please confirm that this calculator applies to your situation.
                        </p>
                        {errorMessage ? (
                          <p
                            style={{
                              color: "#b00020",
                              marginBottom: "1rem",
                              fontSize: "0.95rem",
                            }}
                          >
                            {errorMessage}
                          </p>
                        ) : null}
                        <div className="confirm-modal-content-buttons">
                            <Button isSubmit onClick={onConfirm} disabled={isLoading}>
                                {isLoading ? loadingLabel : "Applies"}
                            </Button>
                            <Button onClick={() => setShowWarning(true)} disabled={isLoading}>
                                Does Not Apply
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ConfirmModal;
